import { slice } from '../slices/snackbar';

const nameSpace = slice.name;

export const notifications = (state: RootState) => state[nameSpace].notifications;
export const palette = (state: RootState) => state[nameSpace].palette;
